import { render, staticRenderFns } from "./DesignInputNumber.vue?vue&type=template&id=2efc36fe&scoped=true&"
import script from "./DesignInputNumber.vue?vue&type=script&lang=js&"
export * from "./DesignInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc36fe",
  null
  
)

export default component.exports